import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import { createFooterlessLayout } from 'apps/new-web/views/pages/create-layout';
import { connect } from 'react-redux';
import ScrollWrapper from 'apps/new-web/views/components/scroll-context';
import ActivateSignUpNav from '../sign-up/components/activate-signup-nav';
import I18n from 'apps/new-web/views/components/i18n';
import DownloadContent from '../app-download/components/download-content';

export class PureDownloadBlePage extends BaseComponent {
  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Get personal virtual fitness training from experts, whether you have [ifit]-enabled equipment, your own equipment, or no equipment! Download [ifit] apps now.', { 'ifit': 'iFIT' }, 'Invites user to join iFIT.') }" />`;
  }

  render() {
    const bleData = {
      topLogo: true,
      header: I18n.translate('Download the [ifit] app.', { ifit: 'iFIT' }, 'Title instructing the user to download the ifit app.'),
      primaryCopy: I18n.translate('To start using [ifit], please download the [ifit] app. Sign in with the account you just created, then follow the steps to pair the app with your machine. Once paired, your machine will be unlocked!', { ifit: 'iFIT' }),
      bottomCopy: I18n.translate('[paragraphStart]Don’t have a TABLET or SMARTPHONE? [linkStart]Activate without one[linkEnd].[svg][paragraphEnd]', { paragraphStart: '<p>', paragraphEnd: '</p>', linkStart: '<a target="_blank" href="/activate-machine">', linkEnd: '</a>', svg: '<svg class="ifit-react-icon" width="24px" height="24px" viewBox="0 0 24 24" data-icon-name="ARROW_FORWARD_LINE" style="display: inline-block; vertical-align: middle;"><path d="M12.053 5L5 12.053l7.058 7.07.693-.692-5.864-5.878h12.908v-1H6.886l5.86-5.86z" fill-rule="evenodd" style="fill: rgb(255, 255, 255); transform-origin: 50% 50%; transform: rotate(180deg);"></path></svg>' }, 'Link telling the user to activate their equipment without a smart device.')
    };

    return (
      <div className="download-app-page">
        <ScrollWrapper>
          <ActivateSignUpNav link="/" />
          <section
            aria-label={ I18n.translate('Download [ifit] apps.', { ifit: 'iFIT' }, 'Header announcing this is where the user will download the app.' ) }
            className="download-page-content"
          >
            <div className="scrim" />
            <DownloadContent data={ bleData } />
          </section>
        </ScrollWrapper>
      </div>
    );
  }
}

const DownloadBlePage = connect((state) => {
  return {
    layout: state.layout,
  };
})(PureDownloadBlePage);

export default createFooterlessLayout(DownloadBlePage);
